import React from 'react';
import cn from 'classnames'

import cls from './Index.module.scss'

interface ICardProps {
    title: string;
    icon?: string;
    result?: string;
    data?: string[];
    action?: string;
    children?: React.ReactNode;
    green?: boolean;
}

export const Card = ({title, icon, result, children, green}: ICardProps) => (
        <div className={cn([cls.card, green && cls.green])}>
            <div className={cls.top}>
                <div className={cls.title}>{icon && `${icon} `}{title}</div>
                <div className={cls.result}>{result}</div>
            </div>
            {children}
        </div>
    )